<!-- 景区-积分结算-结算详情-订单详情 -->

<template>
  <div class="scenic-settlement-order-detail">
    <w-dialog ref="detailDialogRef" title="门票订单详情" width="60%" btnWidth="140px" top="5vh" :hideFooter="true"
      class="order-detail">
      <div class="basic-info">
        <el-descriptions :column="3" border>
          <el-descriptions-item v-for="(el, index) in basicInfo" :key="index" :label="el.label">
            <span :style="{
              color: el.color ? el.color[el.value] : '',
            }">{{ el.text ? el.text[el.value] : el.value }}</span></el-descriptions-item>
        </el-descriptions>
        <div class="flex">
          <div class="remark">备注</div>
          <span class="text-black">{{ detailInfo.ot_remark }}</span>
        </div>
      </div>
      <div class="font-999">游客信息</div>
      <common-table ref="peopleTableRef" :ischeck="false" :ispaging="false" :tableData="peopleData"
        :columns="peopleTableColumns">
        <template #pass_status="{ row }">
          <span :style="'color:' + passStatusColors[row.pass_status]">{{
            ["", "未通行", "通行中", "已通行"][row.pass_status]
          }}</span>
        </template>
      </common-table>

      <br />
      <div class="font-999">景点分账明细</div>
      <common-table ref="accountTableRef" :ischeck="false" :ispaging="false" :tableData="accountData"
        :columns="accountTableColumns">
      </common-table>
      <br />
      <div class="font-999">退款明细</div>
      <common-table ref="refundTableRef" :ischeck="false" :ispaging="false" :tableData="refundData"
        :columns="refundTableColumns">
      </common-table>
    </w-dialog>
  </div>
</template>

<script>
import { ref, computed, watch, nextTick } from "vue";
import { OrderApi } from "@/plugins/api.js";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { getPassStatusColors } from "@/utils/common.js";

export default {
  emits: ["submit"],
  components: {},
  setup() {
    const passStatusColors = ref(getPassStatusColors());
    const detailDialogRef = ref(null);
    const basicInfo = ref({});
    const detailInfo = ref({});
    const store = useStore();
    const peopleData = ref([]);
    const accountData = ref([]);
    const refundData = ref([]);

    const menuTokens = computed(() => store.state.menuToken.menuTokens);
    const authData = ref([]);
    const peopleTableColumns = ref([
      {
        prop: "name",
        label: "游客名",
      },
      {
        prop: "mobile",
        label: "手机号",
      },
      {
        prop: "idcard",
        label: "身份证",
        minWidth: 140,
      },
      {
        prop: "pass_status",
        label: "通行状态",
        type: "customRender",
      },
    ]);

    const accountTableColumns = ref([
      {
        prop: "name",
        label: "景区名称",
      },
      {
        prop: "money",
        label: "分账金额",
      },
    ]);
    const refundTableColumns = ref([
      {
        prop: "refund_sn",
        label: "退款单号",
      },
      {
        prop: "refund_money",
        label: "退款金额",
      },
      {
        prop: "refund_payway_name",
        label: "退款方式",
      },
      {
        prop: "refund_confirm_user",
        label: "退款确认人",
      },
      {
        prop: "refund_confirm_time",
        label: "退款时间",
      },
      {
        prop: "refund_remark",
        label: "退款原因",
      },
    ]);
    watch(
      () => menuTokens.value,
      (data) => {
        if (data.length) {
          authData.value = data;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );
    function getDetail() {
      OrderApi.hotelTicketDetail({ sn: snId.value }).then((res) => {
        if (res.Code === 200) {
          detailInfo.value = res.Data;
          peopleData.value = res.Data.reservation || [];
          accountData.value = res.Data.ledger_account || [];
          refundData.value = res.Data.refund || [];
          peopleData.value.length &&
            peopleData.value.forEach((el) => {
              if (
                res.Data.pay_status == 2 &&
                detailInfo.value.ot_sale_way != 2 &&
                [3, 4].includes(res.Data.work_status)
              ) {
                el.detailStatus = 1;
              } else {
                el.detailStatus = 2;
              }
              if (
                detailInfo.value.pay_status == 2 &&
                el.is_permit_refund == 1 &&
                detailInfo.value.ot_sale_way != 2 &&
                detailInfo.value.or_type == 2
              ) {
                el.refundStatus = 1;
              } else {
                el.refundStatus = 2;
              }
            });

          basicInfo.value = [
            {
              label: "门票名称",
              value: detailInfo.value.ticket_name
                ? detailInfo.value.ticket_name
                : "-",
            },
            {
              label: "门票类型",
              value: detailInfo.value.ticket_type_name
                ? detailInfo.value.ticket_type_name
                : "-",
            },
            {
              label: "所属景区",
              value: detailInfo.value.scenic_name
                ? detailInfo.value.scenic_name
                : "-",
            },
            {
              label: "订单号码",
              value: detailInfo.value.sn ? detailInfo.value.sn : "-",
            },
            {
              label: "购买渠道",
              value: detailInfo.value.source_text
                ? detailInfo.value.source_text
                : "-",
            },
            {
              label: "支付方式",
              value: detailInfo.value.payway_name
                ? detailInfo.value.ar_name
                  ? detailInfo.value.payway_name +
                  "(" +
                  detailInfo.value.ar_name +
                  "-" +
                  detailInfo.value.ar_tourist +
                  ")"
                  : detailInfo.value.payway_name
                : "-",
            },
            {
              label: "下单时间",
              value: detailInfo.value.ctime ? detailInfo.value.ctime : "-",
            },
            {
              label: "购买数量",
              value: detailInfo.value.buy_num ? detailInfo.value.buy_num : "-",
            },
            {
              label: "支付金额",
              value: detailInfo.value.pay_money
                ? detailInfo.value.pay_money + "元"
                : "-",
            },
            {
              label: "支付时间",
              value: detailInfo.value.pay_time
                ? detailInfo.value.pay_time
                : "-",
            },
            {
              label: "退款数量",
              value: detailInfo.value.refund_num
                ? detailInfo.value.refund_num
                : "-",
            },

            {
              label: "退款金额",
              value:
                +detailInfo.value.refund_money > 0
                  ? detailInfo.value.refund_money + "元"
                  : "-",
            },
            {
              label: "优惠金额",
              value:
                +detailInfo.value.yh_money > 0
                  ? detailInfo.value.yh_money + "元"
                  : "-",
            },
            {
              label: "代金券",
              value:
                +detailInfo.value.coupon_money > 0
                  ? detailInfo.value.coupon_money + "元"
                  : "-",
            },
            {
              label: "支付状态",
              value: detailInfo.value.pay_status
                ? detailInfo.value.pay_status
                : "-",
              color: allStatusData.value?.payStatus?.colors,
              text: allStatusData.value?.payStatus?.options,
            },
            {
              label: "业务状态",
              value: detailInfo.value.work_status
                ? detailInfo.value.work_status
                : "-",
              color: allStatusData.value?.workStatus?.colors,
              text: allStatusData.value?.workStatus?.options,
            },

            {
              label: "销售模式",
              value: detailInfo.value.sale_way_text
                ? detailInfo.value.sale_way_text
                : "-",
            },
            {
              label: "分销商",
              value: detailInfo.value.agent_name
                ? detailInfo.value.agent_name
                : "-",
            },
            {
              label: "使用期限",
              value: detailInfo.value.sdate
                ? detailInfo.value.sdate + "至" + detailInfo.value.edate
                : "-",
            },
          ];

          detailDialogRef.value.show();
          nextTick(() => {
            if (peopleData.value.length != 0) {
              peopleTableRef.value.tableLoad();
            }
            if (accountData.value.length != 0) {
              accountTableRef.value.tableLoad();
            }
            if (refundData.value.length != 0) {
              refundTableRef.value.tableLoad();
            }
          });
        } else {
          let msg = res.Message ? res.Message : "获取详情失败！";
          ElMessage.error(msg);
        }
      });
    }
    const snId = ref(null);
    const peopleTableRef = ref(null);
    const accountTableRef = ref(null);
    const refundTableRef = ref(null);

    const allStatusData = ref({});
    function openDialog(id, data) {
      allStatusData.value = data;
      snId.value = id;
      getDetail();
    }
    function closeDialog() {
      detailDialogRef.value.close();
    }
    return {
      closeDialog,
      basicInfo,
      detailDialogRef,
      openDialog,
      detailInfo,
      authData,
      peopleData,
      peopleTableRef,
      peopleTableColumns,
      accountTableRef,
      accountData,
      accountTableColumns,
      refundData,
      refundTableRef,
      refundTableColumns,
      passStatusColors,
    };
  },
};
</script>

<style lang="scss">
.scenic-settlement-order-detail {
  .order-detail {
    .el-dialog__body {
      padding-bottom: 200px;
    }

    .flex {
      display: flex;
    }

    .text-black {
      color: var(--text-color);
    }

    .basic-info {
      border-radius: 4px;
      margin-bottom: 30px;
      padding: 16px 30px 12px 30px;
      background-color: var(--search-uncheck-bg-color);

      .remark {
        color: var(--text-gray-color);
        width: 64px;
        flex-shrink: 0;
      }

      .el-descriptions__body {
        border: none;
        background-color: var(--search-uncheck-bg-color);

        .el-descriptions__label,
        .el-descriptions__content {
          border: 1px solid transparent;
          background-color: var(--search-uncheck-bg-color);
        }

        .el-descriptions__label {
          width: 64px;
          color: var(--text-gray-color);
          font-weight: normal;
        }

        .el-descriptions__cell {
          padding: 0 0 4px 0;
        }

        .el-descriptions__content {
          color: var(--text-color);
          min-width: 100px;
        }
      }
    }

    .refund-desc {
      >span {
        color: var(--text-third-color);
      }

      .info {
        background-color: var(--search-uncheck-bg-color);
        padding: 16px 30px;
        border-radius: 4px;
        color: var(--text-gray-color);
      }
    }
  }
}
</style>
